var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeometricShapeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "60px",
    viewBox: "0 0 54 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kaart",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-325.000000, -369.000000)",
    fill: "currentColor",
    fillRule: "nonzero",
    id: "Group-3-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.230000, 369.630000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.91,40.1945253 L52.91,18.2837917 C52.91,15.666252 51.5054032,13.2475706 49.2254596,11.9388008 L30.1395404,0.981602302 C27.8595389,-0.327200767 25.0504611,-0.327200767 22.7704596,0.981602302 L3.68454039,11.9388008 C1.40459678,13.2475706 0,15.666252 0,18.2837917 C0,18.9044092 0,19.4699039 0,19.9802756 C0,20.3857064 0,20.8472477 0,21.3648996 C0,24.7388397 0,31.0153816 0,40.1945253 C0.00532464174,42.8068281 1.40915035,45.2187138 3.68454039,46.5248626 L22.7704596,57.4783977 C25.0504611,58.7872008 27.8595389,58.7872008 30.1395404,57.4783977 L49.2254596,46.5248626 C51.5008497,45.2187138 52.9046754,42.8068281 52.91,40.1945253 Z",
    id: "Path-Copy-11",
    transform: "translate(26.455000, 29.230000) rotate(-180.000000) translate(-26.455000, -29.230000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometricShapeDefault);
export default __webpack_public_path__ + "static/media/geometric-shape-default.4781a0ed.svg";
export { ForwardRef as ReactComponent };